import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_SERVER_URL,
  headers: {
    "Content-Type": "application/json",
    Accept: "*/*",
  },
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (!error.response) {
      error.response = {
        status: 0,
        data: { code: "timeout", description: "timeout" },
      };
    }

    return Promise.reject(error);
  }
);

export default api;
